<template>
  <div class="register" v-loading.fullscreen.lock="loading">
    <div class="register_header">
      <div class="register_headerCont">
        <div class="register_header_log">
          <img src="@/assets/image/logo_header.png" />
          <span>中医医术确有专长人员医师资格考核报名系统</span>
          <div class="editionType" v-if="editionType">{{testTxt}}</div>
        </div>
        <div class="register_header_link">
          <span>已有账号？</span>
          <router-link :to="{path:'/login'}">请登录</router-link>
        </div>
      </div>
    </div>
    <div class="register_content">
      <div class="register_content_box">
        <div class="register_Steps">
          <Steps :current="currentIn">
            <Step title="帐号注册"></Step>
            <Step title="注册成功"></Step>
          </Steps>
        </div>
        <div class="register_form">
          <div class="register_form_current">
            <template v-if="currentIn==0">
              <Form
                ref="registerCustom"
                :model="registerForm"
                :rules="registerFormRule"
                :label-width="80"
              >
                <FormItem label="手机号:" prop="phone">
                  <Input
                    type="tel"
                    v-model="registerForm.phone"
                    :maxlength="11"
                    placeholder="请输入手机号，默认为登陆用户名"
                  />
                </FormItem>
                <FormItem label="验证码:" prop="Code">
                  <div class="register_form_itemCode">
                    <Input
                      type="tel"
                      v-model="registerForm.Code"
                      :maxlength="11"
                      placeholder="请输入验证码"
                    />
                    <Button class="sendcodeBtn" :disabled="sendcode" @click="sendCodes">
                      <span v-if="!sendcode">发送验证码</span>
                      <span v-else>{{sendTime}}s重新获取</span>
                    </Button>
                  </div>
                </FormItem>
                <FormItem label="姓名" prop="name">
                  <Input v-model="registerForm.name" placeholder="请输入姓名" />
                </FormItem>
                <FormItem label="证件类型" prop="idCrdType">
                  <Select v-model="registerForm.idCrdType" placeholder="请选择证件类型">
                    <Option
                      :value="item.itemvalue1"
                      v-for="item in IdcardList"
                      :key="item.id"
                    >{{item.name}}</Option>
                  </Select>
                </FormItem>
                <FormItem label="证件号码" prop="idCrd">
                  <Input v-model="registerForm.idCrd" placeholder="请输入证件号码" />
                </FormItem>
                <FormItem label="密码" prop="passwd">
                  <Input
                    type="password"
                    password
                    v-model="registerForm.passwd"
                    placeholder="请输入密码"
                  />
                </FormItem>
                <FormItem label="重复密码" prop="passwdCheck">
                  <Input
                    type="password"
                    password
                    v-model="registerForm.passwdCheck"
                    placeholder="请再次输入密码"
                  />
                </FormItem>
                <p class="password_hint">注:密码必须包含6-12位字符,其中必须包含数字和英文</p>
              </Form>
            </template>
            <div class="register_form_btn" v-if="currentIn == 0">
              <Button type="primary" @click="submit">提交</Button>
            </div>
            <div class="register_success" v-if="currentIn==1">
              <div class="register_success_icon">
                <img src="@/assets/image/zccg.png" />
                <h3>注册成功</h3>
              </div>
              <div class="register_success_userNew">
                <div class="register_success_userNewItem">
                  <span class="lables">手机号</span>
                  <span class="values">{{this.registerForm.phone}}</span>
                </div>
                <div class="register_success_userNewItem">
                  <span class="lables">姓名</span>
                  <span class="values">{{this.registerForm.name}}</span>
                </div>
                <div class="register_success_userNewItem">
                  <span class="lables">身份证</span>
                  <span class="values">{{this.registerForm.idCrd}}</span>
                </div>
              </div>
              <div class="register_success_btn">
                <Button type="primary" :to="{path:'/login'}">立即登录</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="register_footer">
      <span class="lable">主办单位：</span>
      <span class="txt">四川省中医药管理局</span>
      <span class="npsp"></span>
      <span class="lable">技术支持：</span>
      <span class="txt">武汉品亿信息技术有限公司</span>
    </div>
  </div>
</template>
<style lang="less">
.register {
  height: 100%;
  position: relative;
  .register_header {
    height: 60px;
    background: #fff;
    .register_headerCont {
      height: 60px;
      width: 1200px;
      margin: 0 auto;
      position: relative;
      .register_header_log {
        float: left;
        height: 60px;
        img {
          position: relative;
          top: 10px;
        }
        span {
          display: inline-block;
          font-weight: bold;
          font-size: 13px;
          color: #9c9c9c;
          padding-left: 15px;
          border-left: 1.5px solid #9c9c9c;
          margin-left: 15px;
          position: relative;
          top: -3px;
        }
        .editionType {
          position: absolute;
          left: 540px;
          top: 13px;
          height: 35px;
          line-height: 35px;
          color: #fff;
          background: #ff0000;
          padding: 0 20px;
          font-size: 18px;
        }
      }
      .register_header_link {
        float: right;
        height: 60px;
        line-height: 60px;
        a {
          color: #00b49b;
        }
      }
    }
  }
  .register_content {
    width: 100%;
    height: calc(100% - 60px);
    background: url("./../../../assets/image/bg.png") repeat-y top center;
    overflow: hidden;
    .register_content_box {
      width: 500px;
      margin: 3% auto 0;
    }
    .register_Steps {
      height: 60px;
    }

    .register_form {
      margin: 0 auto 0;
      padding: 0 30px;
      box-sizing: border-box;

      .register_form_itemCode {
        padding-right: 125px;
        box-sizing: border-box;
        position: relative;

        .sendcodeBtn {
          position: absolute;
          right: 0;
          top: 0;
          border-color: #00b49b;
          color: #00b49b;
        }
      }
      .password_hint {
        color: #ff0000;
        font-size: 12px;
        padding-left: 90px;
        box-sizing: border-box;
        margin-bottom: 15px;
      }
      .register_form_btn {
        padding: 0 0 0 20px;
        box-sizing: border-box;
        text-align: center;

        .ivu-btn {
          background: #00b49b;
        }
      }
    }

    .register_success {
      .register_success_icon {
        text-align: center;
        img {
          display: block;
          width: 190px;
          margin: 0 auto;
        }
        h3 {
          font-size: 22px;
        }
      }

      .register_success_userNew {
        padding-top: 15px;
        width: 65%;
        margin: 0 auto;

        .register_success_userNewItem {
          height: 35px;
          line-height: 35px;
          overflow: hidden;

          .lables {
            float: left;
            font-size: 12px;
            color: #777777;
          }

          .values {
            float: right;
            font-size: 12px;
            color: #777777;
          }
        }
      }

      .register_success_btn {
        text-align: center;
        padding-top: 15px;
        .ivu-btn {
          background: #00b49b;
        }
      }
    }

    .register_footer {
      text-align: right;
      height: 40px;
      line-height: 40px;
      padding: 0 30px;
      box-sizing: border-box;
    }
  }
  .register_footer {
    position: absolute;
    left: 50%;
    bottom: 20px;
    transform: translateX(-50%);
    .lable {
      color: #777777;
      font-size: 14px;
    }
    .txt {
      color: #00b49b;
      font-size: 14px;
    }
    .npsp {
      padding: 0 20px;
    }
  }
}
</style>
<script>
import { AccountRegister, sendCode } from "@/api/account/index";
import { IDCardDictionaries } from "@/api/dictionaries/index";
import util from "@/libs/util";
export default {
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else {
        const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error("请输入正确手机号"));
        }
      }
    };
    const validateCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else {
        if (value.length > 5) {
          callback();
        } else {
          callback(new Error("请输入六位验证码"));
        }
      }
    };
    const validateName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入姓名"));
      } else {
        callback();
      }
    };
    const validateidCrdType = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择证件类型"));
      } else {
        this.$refs.registerCustom.validateField("idCrd");
        callback();
      }
    };
    const validateidCrd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入证件号码"));
      } else {
        if (this.registerForm.idCrdType == "") {
          this.$refs.registerCustom.validateField("idCrdType");
          callback(new Error("请选择证件类型"));
        } else {
          if (this.registerForm.idCrdType == "1") {
            if (util.tool.checkIDCard(value)) {
              callback();
            } else {
              callback(new Error("身份证号输入错误"));
            }
          } else {
            callback();
          }
        }
      }
    };
    const validatepasswd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/;
        if (reg.test(value)) {
          if (this.registerForm.passwdCheck !== "") {
            // 对第二个密码框单独验证
            this.$refs.registerCustom.validateField("passwdCheck");
          }
          callback();
        } else {
          callback(new Error("密码不符合规则"));
        }
      }
    };
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请重新输入密码"));
      } else if (value !== this.registerForm.passwd) {
        callback(new Error("两个输入密码不匹配!"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      currentIn: 0,
      sendcode: false,
      timeOut: null,
      sendTime: 60,
      IdcardList: [],
      registerForm: {
        phone: "",
        Code: "",
        name: "",
        idCrdType: "1",
        idCrd: "",
        passwd: "",
        passwdCheck: ""
      },
      registerFormRule: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            validator: validatePhone,
            trigger: "blur"
          }
        ],
        Code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          {
            validator: validateCode,
            trigger: "blur"
          }
        ],
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            validator: validateName,
            trigger: "blur"
          }
        ],
        idCrdType: [
          { required: true, message: "请选择证件类型", trigger: "change" },
          {
            validator: validateidCrdType,
            trigger: "change"
          }
        ],
        idCrd: [
          { required: true, message: "请输入证件号码", trigger: "blur" },
          {
            validator: validateidCrd,
            trigger: "blur"
          }
        ],
        passwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            validator: validatepasswd,
            trigger: "blur"
          }
        ],
        passwdCheck: [
          { required: true, message: "请输入重复密码", trigger: "blur" },
          {
            validator: validatePassCheck,
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.getIdCar();
  },
  methods: {
    //证件类型数据字典
    getIdCar() {
      this.loading = true;
      IDCardDictionaries("idcard_type").then(res => {
        this.IdcardList = res.data_item_dtls;
        this.loading = false;
      });
    },
    //发送验证码
    sendCodes() {
      if (this.registerForm.phone == "") {
        this.$refs.registerCustom.validateField("phone");
      } else {
        const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (reg.test(this.registerForm.phone)) {
          this.loading = true;
          let params = {
            operation: "stu_reg_code",
            phone: this.registerForm.phone
          };
          sendCode(params)
            .then(() => {
              this.loading = false;
              this.$Message.success("短信已发送，请耐心等待！");
              let times = 60;
              this.sendcode = true;
              this.timeOut = setInterval(() => {
                if (times < 2) {
                  this.sendcode = false;
                  clearInterval(this.timeOut);
                  this.sendTime = 60;
                } else {
                  --times;
                  this.sendTime = times;
                }
              }, 1000);
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          this.$refs.registerCustom.validateField("phone");
        }
      }
    },
    //提交
    submit() {
      this.$refs.registerCustom.validate(valid => {
        if (valid) {
          this.loading = true;
          let params = {
            name: this.registerForm.name,
            idcard_type: this.registerForm.idCrdType,
            idcard_no: this.registerForm.idCrd,
            phonenum: this.registerForm.phone,
            phone_code: this.registerForm.Code,
            password: this.$md5(this.registerForm.passwd),
            password2: this.$md5(this.registerForm.passwdCheck)
          };
          AccountRegister(params)
            .then(() => {
              this.loading = false;
              this.currentIn = this.currentIn + 1;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>